import { CalendarEvent } from "angular-calendar";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { IContentManager } from "src/app/core/models/content-manager/icontent-manager";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { ContentManager } from "src/app/core/helpers/content-manager/content-manager";
import { environment } from "src/environments/environment";
import { DateTimeService } from "src/app/core/utils/datetime.service";

@Component({
    selector: "app-calendar",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./calendar.component.html",
    styleUrls: ["./calendar.component.scss"],
    standalone: false
})
export class CalendarComponent implements OnInit {
  view = "month";
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];
  clickedDate: Date;
  clickedColumn: number;
  dateReset: string;
  date: any = {};
  locale;
  infoContentManager: Array<IContentManager>;
  pInfoDate: IContentManager;
  showCardBlue: boolean;

  constructor(
    private _storage: LocalStorageService,
    private dateTimeService:DateTimeService) { }

  ngOnInit() {
    this.pInfoDate = new IContentManager();
    this.pInfoDate.text = "No hay eventos";
    this.pInfoDate.text_html = "En el día seleccionado no hay ningún evento..";
    this.infoContentManager = ContentManager.contentExtraction(
      this._storage.getItemJSON(environment.LOCAL_STORAGE.GESTOR_CONTENIDO),
      "dashboard",
      "calendar"
    );
  }

  fillInfoContentManager(dateSelect: Date): boolean {
    let found = false;
    this.infoContentManager.forEach((val) => {
      const date = new Date(val.date);
      if (this.compateDate(dateSelect, date)) {
        this.pInfoDate = val;
        found = true;
      }
    });
    return found;
  }

  compateDate(date1: Date, date2: Date): boolean {
    return (
      date1.getMonth === date2.getMonth &&
      date1.getDate() === date2.getDate() + 1 &&
      date1.getFullYear() === date2.getFullYear()
    );
  }

  clickDay() {
    const dateCalendar = this.clickedDate;
    const month = dateCalendar.getMonth();

    this.date.day = dateCalendar.getDate();
    this.date.month = this.dateTimeService.formatearMes(month, 'MMMM');
    this.date.year = dateCalendar.getFullYear();

    this.showCardBlue = true;

    if (!this.fillInfoContentManager(dateCalendar)) {
      this.pInfoDate = new IContentManager();
      this.pInfoDate.text = "No hay eventos";
      this.pInfoDate.text_html =
        "En el día seleccionado no hay ningún evento..";
    }
  }
}
